import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import React, { useState, useEffect } from "react";
import axios from "axios";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Wrapper from "../../../components/UI/Wrapper";
import "../../../pages/SalesMasterPages/MRPSheet/MRPSheet.css";


const MRPSheet = () => {
  
  const [serviceType, setServiceType] = useState(1);
  const [products, setProducts] = useState(null);

  const baseAPI = process.env.REACT_APP_API_URL;

  const [firstItem, setFirstItem] = useState({
    serviceType: "",
    subCategory: "",
    description: "",
    qty: "",
    sellingExGst: "",
    deliveryCharges: "",
    gstRate: "",
    gst: "",
    sellingInGst: "",

    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem({
      ...firstItem,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}userpost/AddMRPSheet`,
        firstItem, // Send firstItem as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Handle the response here (e.g., show a success message)
     

      // Optionally, reset the form
      setFirstItem({
        serviceType: "",
        subCategory: "",
        description: "",
        qty: "",
        sellingExGst: "",
        deliveryCharges: "",
        gstRate: "",
        gst: "",
        sellingInGst: "",

        createdBy: "Vishal",
        is_active: "true",
      });
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

useEffect(() => {
  const storedToken = JSON.parse(localStorage.getItem("token"));
  axios
    .get(
      `${baseAPI}userget/GetMRPSheet?mrpsheet_id=0`,
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      }
    )
    .then((response) => {
      setProducts(response.data.data);
    })
    .catch((error) => {
      console.error("Error fetching user detail:", error);
    });

}, []);

  return (
    <>
      <div className="app-container-MRPSheet">
        <MiniDrawer />
        <div className="container-fluid container-MRPSheet">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                MRP Sheet| <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; MRP Sheet</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA </option>
                <option value="1">DUBAI </option>
              </select>
            </div>
          </div>
          <Wrapper className="MRPSheet">
            <form className="MRPSheet-form" onSubmit={handleSubmit}>
              <table>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>SERVICE TYPE</td>
                  <td>SUB CATEGORY</td>
                  <td>DESCRIPTION</td>
                </tr>

                <tr>
                  <td>
                    <select
                      className="form-control"
                      name="serviceType"
                      value={serviceType}
                      onChange={handleChange}
                    >
                      <option value="0">Please Select</option>
                      <option value="1">INTERNATIONAL</option>
                      <option value="2">DOMESTIC</option>
                      <option value="3">BOTH</option>
                      <ArrowDropDownIcon />
                    </select>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      name="serviceType"
                      value={firstItem.subCategory}
                      onChange={handleChange}
                    >
                      <option value="0">Please Select</option>
                      <option value="1">DOOR DELIVERY (International)</option>
                      <option value="2">PET MATE CAGE (Domestic)</option>
                      <option value="3">CAGE SIZE (Domestic)</option>
                      <ArrowDropDownIcon />
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="description"
                      value={firstItem.description}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>QTY</td>
                  <td>SELLING EX-GST</td>
                  <td>DELIVERY CHARGES</td>
                </tr>

                <tr>
                  <td>
                    <input
                      type="number"
                      name="qty"
                      value={firstItem.qty}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="sellingExGst"
                      value={firstItem.sellingExGst}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="deliveryCharges"
                      value={firstItem.deliveryCharges}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr className="space">
                  <td colSpan={3}></td>
                </tr>
                <tr className="tableHeading">
                  <td>GST RATE</td>
                  <td>GST</td>
                  <td>SELLING IN-GST</td>
                </tr>

                <tr>
                  <td>
                    <input
                      type="text"
                      name="gstRate"
                      value={firstItem.gstRate}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="gst"
                      value={firstItem.gst}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="sellingInGst"
                      value={firstItem.sellingInGst}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                </tr>
              </table>
              <br />
              <hr />
              <div className="reset-addMRPSheet-button">
                <button style={{ backgroundColor: "#F15843", color: "white" }}>
                  Reset
                </button>
                <button
                  type="submit"
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#5B489D",
                    color: "white",
                  }}
                >
                  Save
                </button>
              </div>
            </form>
          </Wrapper>
          <br />
          <Wrapper className="ViewLeadDetails">
            <div className="container-fluid">
              <div className="employeeList">
                <table>
                  <tr className="employeeListHeading">
                    <th>S No.</th>
                    <th>Description</th>
                    <th>SERVICE TYPE</th>
                    <th>SUB CATEGORY</th>
                    <th>SELLING EX-GST</th>
                    <th>DELIVERY CHARGES</th>
                    <th>GST RATE</th>
                    <th>GST</th>
                    <th>SELLING IN-GST</th>
                    
                  </tr>
                  {products !== null ? (
                    products.map((product, index) => (
                      <tr key={product.mrpsheet_id}>
                        <td>{++index}</td>
                        <td>{product.description}</td>
                        <td>{product.service_typename}</td>
                        <td>{product.category}</td>
                        <td>{product.selling_ex_gst} </td>
                        <td>{product.delivery_charges}</td>
                        <td>{product.gst_rate}</td>
                        <td>{product.gst}</td>
                        <td>{product.selling_in_gst}</td>
                        
                      </tr>
                    ))
                  ) : (
                    <p>empty</p>
                  )}
                </table>
              </div>
            </div>
          </Wrapper>
        </div>
      </div>
    </>
  );
};
export default MRPSheet;